import { AUTHENTICATION } from "../authentication/authenticationConstants.js";
import { CORE } from "../../actions/actionConstants.js";

export const INITIAL = {
  isReady: false
};

export const coreReducer = (state = INITIAL, action = {}) => {
  switch (action.type) {
    case CORE.GET_COMPLETE:
      return {
        ...state,
        isReady: true
      };

    case AUTHENTICATION.LOGOUT.DO:
    case AUTHENTICATION.LOGIN.FAILURE:
      return INITIAL;

    default:
      return state;
  }
};
